'use client';

import React, { type ForwardedRef, forwardRef, useState } from 'react';
import { ToastContents } from './ToastAlertContents';
import type { ToastContentsProps } from './ToastTypes';

type ToastLoadingProps = Pick<
  ToastContentsProps,
  'title' | 'details' | 'isLoading'
>;

export const ToastLoading = forwardRef(
  (
    { title, details, isLoading }: ToastLoadingProps,
    forwardedRef: ForwardedRef<HTMLDivElement>
  ) => {
    const [cachedProps, setCachedProps] = useState({ title, details });

    if (
      isLoading &&
      (title !== cachedProps.title || details !== cachedProps.details)
    ) {
      // prevent our title / details from updating if we are still showing
      // our loading state during its unmount
      setCachedProps({ title, details });
    }

    return (
      <ToastContents
        ref={forwardedRef}
        details={cachedProps.details}
        isLoading={true}
        title={cachedProps.title}
      />
    );
  }
);
